import React, { Fragment } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ItemList, NWDonutChart, SubTitle } from 'components';
import './PieChart.scss';

const PieChart = ({ title, data, intl }) => (
  <div className="nw-page-fundfactsheet__pie">
    <SubTitle title={(<FormattedMessage id={title} />)} />
    <div className="nw-page-fundfactsheet__chart" style={{ height: data.length * 50 + 200 }}>
      <NWDonutChart
        isLegend
        legendAlign="center"
        legendVerticalAlign="bottom"
        labelFill="#757679"
        legendWidth="100%"
        legendStyle={{ transform: 'translateY(30px)' }}
        pieName={intl.formatMessage({ id: title })}
        data={data}
        innerRadius={55}
        outerRadius={70}
        customLegend={props => (
          <ItemList
            data={props.payload.map(i => ({
              label: (
                <Fragment key={i}>
                  <svg
                    className="recharts-surface"
                    width="8"
                    height="8"
                    viewBox="0 0 32 32"
                    style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
                  >
                    <path
                      fill={i.payload.color}
                      className="recharts-symbols"
                      transform="translate(16, 16)"
                      d="M16,0A16,16,0,1,1,-16,0A16,16,0,1,1,16,0"
                    />
                  </svg>
                  <span className="recharts-legend-item-text">{i.value}</span>
                </Fragment>
              ),
              value: `${i.payload.value % 1 !== 0 ? (i.payload.value).toFixed(2) : i.payload.value} %`,
            }))}
          />
        )}
      />
    </div>
  </div>
);

export default injectIntl(PieChart);
